import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData, IResponseData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";

import {TombOfNefertitiGameAssets} from "./TombOfNefertitiGameAssets";
import {TombOfNefertitiGameMode} from "./gamemode/TombOfNefertitiGameMode";
import {TombOfNefertitiSoundConfig} from "./TombOfNefertitiSoundConfig";
import {TombOfNefertiti} from "./TombOfNefertiti";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {TombOfNefertitiGameModuleConfig} from "./TombOfNefertitiGameModuleConfig";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {TombOfNefertitiMultiplierEvents} from "./multiplierIndicator/TombOfNefertitiMultiplier";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";


export class TombOfNefertitiPromoPanelConfig implements PromoPanelGameConfiguration {
    constructor() {
    }


    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "TombOfNefertiti",
            hasActionSpin: true,
            graphics: {backgroundTextureName: TombOfNefertitiGameAssets.BACKGROUND},
            getParsedData: (response: any, bet: number, prevResponse: any): ASWinData => {
                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    totalSpinWinnings: this.getSpinWin(response, bet, prevResponse),
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: false,

                }
                return parsedData;
            }
        };
    }

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            TombOfNefertiti.sound.playEffect(TombOfNefertitiSoundConfig.instance.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            TombOfNefertiti.sound.playEffect(TombOfNefertitiSoundConfig.instance.AS_WIN_BIG);
        }
    }

    onPlayBonusInGame(data: any) {
        this.restoreBaseGameReels(data);
        EventHandler.dispatchEvent(new GameEvent(ServerEvent.GAME_DATA_RECEIVED, data));
        if (data.mode === TombOfNefertitiGameMode.RESPIN) {
            EventHandler.dispatchEvent(new GameEvent("updateMultiForAS", data));
            EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiMultiplierEvents.TRY_MULTIPLIER_UPDATE, true));
        }
        EventHandler.dispatchEvent(new GameEvent(ScreenEvent.GAME_START));
        TombOfNefertiti.keypad.setWin(data.accumulatedRoundWin, true, (TombOfNefertiti.api.gameClientConfiguration.belowStakeWinRestriction && data.accumulatedRoundWin > data.playedBetValue));
    }

    isLegalStopOnBonusMode(response: IResponseData): boolean {
        return (response.mode === TombOfNefertitiGameMode.NORMAL && response.nextMode === TombOfNefertitiGameMode.FREESPIN) || (response.mode === TombOfNefertitiGameMode.RESPIN && response.nextMode === TombOfNefertitiGameMode.FREESPIN);
    }

    private isBigWin(response: any): boolean {
        let win = this.getSpinWin(response, 0, "")
        let winRatio: number = Helper.ceilToDecimals((win / response.playedBetValue), 2);
        return winRatio >= 15;
    }

    private getSpinWin(response: any, bet: number, prevData: any): number {
        if ((response.mode === TombOfNefertitiGameMode.RESPIN_FREESPIN && (response.nextMode === TombOfNefertitiGameMode.FREESPIN || response.nextMode === TombOfNefertitiGameMode.NORMAL)) || (response.mode === TombOfNefertitiGameMode.RESPIN && response.nextMode === TombOfNefertitiGameMode.NORMAL)) {
            return response.totalRespinWin;
        } else {
            return response.totalSpinWinnings;
        }
    }

    private isFreeSpinTriggered(response: any): boolean {
        return (response.mode === TombOfNefertitiGameMode.NORMAL && response.nextMode === TombOfNefertitiGameMode.FREESPIN) || (response.mode === TombOfNefertitiGameMode.RESPIN && response.nextMode === TombOfNefertitiGameMode.FREESPIN);
    }

    private getFeatureName(response: any): string {
        if (response.mode === TombOfNefertitiGameMode.FREESPIN || response.nextMode === TombOfNefertitiGameMode.FREESPIN) {
            return "RAIDER SPINS";
        }
        if (response.mode === TombOfNefertitiGameMode.RESPIN_FREESPIN || response.nextMode === TombOfNefertitiGameMode.RESPIN_FREESPIN) {
            return "RAIDER SPINS";
        }
        return "";
    }

    private restoreBaseGameReels(data: any): void {
        const reels: string[][] = data.evaluatedReels;
        let sym: StateReelSymbol;
        for (let i: number = 0; i < reels.length; i++) {
            for (let j: number = 0; j < reels[i].length; j++) {
                sym = (Reels.getSymbol(i * 3 + j, 0)!);
                sym.replaceWith(reels[i][j], i * 3 + j);
                if (sym.symName === "X") {
                    sym.setVisibility(false);
                }
            }
        }
    }

    private isRoundComplete(response: any): boolean {
        return [TombOfNefertitiGameMode.NORMAL, TombOfNefertitiGameMode.FREESPIN].indexOf(response.nextMode) > -1;
    }

    private isBonusEnd(response: any): boolean {
        return ((response.nextMode === TombOfNefertitiGameMode.NORMAL) && (response.mode === TombOfNefertitiGameMode.FREESPIN || response.mode === TombOfNefertitiGameMode.RESPIN_FREESPIN));
    }


}